import { translationKey, localize } from '../../i18n';
import React from 'react';
import { readAppLanguage } from '../../i18n';
import { Box, Typography } from '@mui/material';
import CalendarCell from './CalendarCell';

const DAY_HEADERS = [translationKey('일'), translationKey('월'), translationKey('화'), translationKey('수'), translationKey('목'), translationKey('금'), translationKey('토')];

function pad2(n) {
    return String(n).padStart(2, '0');
}

export default function CalendarGrid({ year, month, todayDate, selectedDate, cellMedsByDay, onSelectDate }) {
    const language = readAppLanguage();
    const weekdayFormatter = language === 'ko' ? null : new Intl.DateTimeFormat(language === 'ja' ? 'ja-JP' : 'en-US', { weekday: 'short', timeZone: 'UTC' });
    const firstDayOfMonth = new Date(year, month - 1, 1).getDay();
    const daysInMonth = new Date(year, month, 0).getDate();

    const weeks = [];
    let week = Array(firstDayOfMonth).fill(null);
    for (let d = 1; d <= daysInMonth; d++) {
        week.push(d);
        if (week.length === 7) {
            weeks.push(week);
            week = [];
        }
    }
    if (week.length > 0) {
        while (week.length < 7) week.push(null);
        weeks.push(week);
    }

    const today = new Date();
    const isCurrentMonth = year === today.getFullYear() && month === today.getMonth() + 1;

    return (
        <Box>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', mb: '6px' }}>
                {DAY_HEADERS.map((d, i) => (
                    <Typography
                        key={d}
                        sx={{
                            textAlign: 'center',
                            fontSize: '12px',
                            fontWeight: 700,
                            color: i === 0 ? '#ef4444' : i === 6 ? '#3b82f6' : '#888',
                            py: '4px',
                        }}
                    >
                        {weekdayFormatter ? weekdayFormatter.format(new Date(Date.UTC(2020, 0, 5 + i))) : localize(d)}
                    </Typography>
                ))}
            </Box>
            {weeks.map((w, wi) => (
                <Box key={wi} sx={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: '2px', mb: '4px' }}>
                    {w.map((day, di) => {
                        if (!day) return <Box key={di} sx={{ minHeight: 76 }} />;
                        const dateStr = `${year}-${pad2(month)}-${pad2(day)}`;
                        const isToday = isCurrentMonth && day === todayDate;
                        const isSelected = selectedDate === dateStr;
                        const meds = cellMedsByDay.get(dateStr) || [];
                        return (
                            <CalendarCell
                                key={di}
                                date={dateStr}
                                day={day}
                                dow={di}
                                isToday={isToday}
                                isSelected={isSelected}
                                meds={meds}
                                onClick={() => onSelectDate(dateStr)}
                            />
                        );
                    })}
                </Box>
            ))}
        </Box>
    );
}
